import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow, createElementVNode as _createElementVNode, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f3003ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "seatmap-selection",
  "data-js": "seatmap-container",
  class: "o-seatmapSelection"
}
const _hoisted_2 = {
  key: 0,
  class: "o-seatmapSelection__loaderContainer"
}
const _hoisted_3 = {
  key: 2,
  class: "o-seatmapSelection__overlay"
}
const _hoisted_4 = {
  key: 0,
  class: "o-seatmapSelection__loaderContainer"
}
const _hoisted_5 = { class: "o-seatmapSelection__map" }
const _hoisted_6 = {
  ref: "map-container",
  id: "map"
}
const _hoisted_7 = { class: "m-blockNotice__content" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = {
  key: 2,
  class: "o-seatmapSelection__sidebar"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner_component = _resolveComponent("spinner-component")!
  const _component_MobileControls = _resolveComponent("MobileControls")!
  const _component_DesktopControls = _resolveComponent("DesktopControls")!
  const _component_selection_component = _resolveComponent("selection-component")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.seatmapStore.hasGenericError && !_ctx.seatmapStore.isReady)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_spinner_component, {
            dataID: 'map-spinner-component',
            label: _ctx.loadingMessage,
            class: "o-seatmapSelection__loader"
          }, null, 8, ["label"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.seatmapStore.hasGenericError)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([{ 'is-absolute-positioned' : _ctx.isMobile, 'is-relative-positioned': !_ctx.isMobile }, "o-seatmapSelection__errorBlock clearfix"])
        }, [
          _withDirectives((_openBlock(), _createElementBlock("h3", null, [
            _createTextVNode("Seatmap error")
          ])), [
            [_directive_translate, { key: _ctx.Translation.Seatmap_error }]
          ]),
          _withDirectives((_openBlock(), _createElementBlock("p", null, [
            _createTextVNode("Something went awry.")
          ])), [
            [_directive_translate, { key: _ctx.Translation.Seatmap_runtime_error }]
          ])
        ], 2))
      : (_ctx.shouldDisplayUnavailabilityOverlay())
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _withDirectives((_openBlock(), _createElementBlock("h2", null, [
              _createTextVNode("Tickets are currently unavailable")
            ])), [
              [_directive_translate, { key: _ctx.Translation.Seatmap_tickets_unavailable }]
            ])
          ]))
        : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          id: "map-container",
          class: _normalizeClass([{'-hidden' : !_ctx.seatmapStore.isReady}, "o-seatmapSelection__container"])
        }, [
          (!_ctx.seatmapStore.hasGenericError)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_spinner_component, {
                  dataID: 'map-spinner-component',
                  label: _ctx.seatmapStore.hasErrorOnUserInteraction ? '' : _ctx.loadingMessage,
                  class: "o-seatmapSelection__loader"
                }, null, 8, ["label"])
              ], 512)), [
                [_vShow, _ctx.seatmapStore.errorOnUserInteraction || !_ctx.seatmapStore.isReady]
              ])
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, null, 512),
            (_ctx.isMobile)
              ? (_openBlock(), _createBlock(_component_MobileControls, {
                  key: 0,
                  "action-button-label": _ctx.actionButtonLabel,
                  "is-pricelevel-selected": !!_ctx.selectedPriceLevel,
                  onLayerExit: _ctx.handleExitLayerClick
                }, null, 8, ["action-button-label", "is-pricelevel-selected", "onLayerExit"]))
              : (_openBlock(), _createBlock(_component_DesktopControls, {
                  key: 1,
                  data: _ctx.data,
                  "is-pricelevel-selected": !!_ctx.selectedPriceLevel,
                  onZoomLevelChange: _ctx.handleZoomControlChange,
                  onLayerExit: _ctx.handleExitLayerClick
                }, null, 8, ["data", "is-pricelevel-selected", "onZoomLevelChange", "onLayerExit"]))
          ], 512), [
            [_vShow, !_ctx.seatmapStore.hasGenericError]
          ]),
          (_ctx.shouldDisplayNotice)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass([{
                        '-error': _ctx.seatmapStore.hasTicketNumberValidationNotice,
                        '-warning': _ctx.hasAvailabilityLockedBehindPromotions,
                        '-bottomMargin': _ctx.isMobile,
                    }, "m-blockNotice o-seatmapSelection__noticeContainer -small"])
              }, [
                _createElementVNode("div", _hoisted_7, [
                  (_ctx.seatmapStore.hasInvalidSize)
                    ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_8, [
                        _createTextVNode("Selection maximum exceeded notice")
                      ])), [
                        [_directive_translate, {
                            key: _ctx.Translation.Seatmap_max_selection_error,
                            keyValues: JSON.stringify({ 'placeholder-max-selection': _ctx.seatmapStore.maxTickets }),
                                        identifierStart: '{',
                            identifierEnd: '}',
                        }]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.seatmapStore.hasInvalidCartSize)
                    ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_9, [
                        _createTextVNode("Cart maximum exceeded notice")
                      ])), [
                        [_directive_translate, {
                            key: _ctx.Translation.Seatmap_max_cart_error,
                            keyValues: JSON.stringify({ 'placeholder-max-cart': _ctx.seatmapStore.maxCartRestriction() }),
                            identifierStart: '{',
                            identifierEnd: '}',
                        }]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.hasAvailabilityLockedBehindPromotions && !_ctx.shouldDisplayUnavailabilityOverlay())
                    ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_10, [
                        _createTextVNode("Please select promotion")
                      ])), [
                        [_directive_translate, { key: _ctx.Translation.Seatmap_select_promotion }]
                      ])
                    : _createCommentVNode("", true)
                ])
              ], 2))
            : _createCommentVNode("", true),
          (!_ctx.isMobile && !_ctx.seatmapStore.hasGenericError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_selection_component, { data: _ctx.data }, null, 8, ["data"])
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _: 1
    })
  ]))
}